<script lang="ts" setup>
import { ref, toRefs } from 'vue';
import { InputNumberInputEvent } from 'primevue/inputnumber';
import { useProgressReportDropdown } from '@/composables';
import ProgressReportOptions from '@/assets/json/progress_options.json';

interface Props {
  goalId: undefined | number;
}

const props = withDefaults(defineProps<Props>(), { goalId: undefined });

const { goalId } = toRefs(props);

const intensity = ref();

const onChange = (event: InputNumberInputEvent) => useProgressReportDropdown(goalId, 'intensity').onChange(event);
</script>

<template>
  <div>
    <Dropdown
      v-model="intensity"
      :options="ProgressReportOptions.intensities"
      option-label="name"
      option-value="value"
      placeholder="Select Intensity"
      @change="onChange"
    />
  </div>
</template>
